import {get} from 'lodash';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import TabbedCollegeSearch from 'src/components/CollegeSearch/TabbedCollegeSearch/TabbedCollegeSearch';
import {initializeCollegeSearch} from 'src/redux/collegeSearch/actions';
import {EducationPhase} from 'src/types/enums';

const mapStateToProps = (state) => ({
  isSenior: get(state, 'collegeSearch.user.highSchoolInfo.senior', null),
  transfer: state.transfer,
  userType: get(state, 'collegeProfile.userInfo.user', EducationPhase.HIGH_SCHOOL),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      initializeCollegeSearch,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TabbedCollegeSearch);
